
<div class="row card-header">
  <h3>Change Password</h3>
</div>

<div class="marginTop row">
	<div class="col-12" *ngIf="erroralert">
		<div class="alert-box grid-100" *ngIf="errorMessage">
			<div class="alert alert-danger mt-3 text-center">
				<a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a>
				{{errorMessage}}
			</div>
		</div>
	</div>
	<div class="col-12" *ngIf="successalert">
		<div class="alert-box grid-100" *ngIf="successMessage">
			<div class="alert alert-success mt-3 text-center">
				<a class="close link" data-dismiss="alert"  (click)="successalert=false">×</a>
				{{successMessage}}
			</div>
		</div>
	</div>

</div>

<div class="row bg_dashboard justify-content-center">
  <div class="col-11">
    <div class="card text-center">

      <div class="card-body card_main">
         <form class="viewProfileForm" [formGroup]="changePasswordForm" (ngSubmit)="onSubmit(changePasswordForm.value); changePasswordForm.reset()">
          <div class="row justify-content-center">
            <div class="col-4">
              <div class="form-group">
                <input type="password" class="form-control" placeholder="Enter New Password"  id="password" required name="password" formControlName="password" (focus)="onFocusFunction()">
                 <div *ngIf="changePasswordForm.controls['password'].errors && !changePasswordForm.controls['password'].pristine" class="text-danger">
                    <div [hidden]="!changePasswordForm.controls['password'].errors.required">Password is required.</div>
                    <div [hidden]="!changePasswordForm.controls['password'].errors.minlength">Password must be at least 8 characters long.</div>
                  </div>
                <input type="password" class="form-control" placeholder="Retype New Password"  id="password_confirmation" required name="password_confirmation" formControlName="password_confirmation"  (focus)="onFocusFunction()" (keyup)="matchpasswords($event.target.value)">
                <div *ngIf="changePasswordForm.controls['password_confirmation'].errors && !changePasswordForm.controls['password_confirmation'].pristine" class="text-danger">
                    <div [hidden]="!changePasswordForm.controls['password_confirmation'].errors.required">Confirm Password is required.</div>
                  </div>
                <p *ngIf="passwordmatchFlag" class="text-danger">  Password doesn't match!</p>
                <button class="button mt-3" type="submit"  [disabled]="!changePasswordForm.valid">Submit</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/authentication/changepassword/changepassword.component.html